import { DatePicker, Space, Tag, Typography } from "antd";
import { DateRenderer } from "./date-renderer";
import dayjs from "dayjs";
const { Text, Paragraph } = Typography;

export const columns = [
  {
    title: "Message",
    dataIndex: "message",
    key: "message",
    render: (text: string) => (
      <Text type="danger" style={{ whiteSpace: "pre-wrap" }}>
        {text}
      </Text>
    ),
  },
  {
    title: "Inner Exception",
    dataIndex: "innerExceptionMessage",
    key: "innerExceptionMessage",
    render: (text: string | null) => {
      if (!text) return "";
      return (
        <Paragraph
          copyable
          ellipsis={{ rows: 1, expandable: true, symbol: "more" }}
          style={{ whiteSpace: "pre-wrap" }}
        >
          {text}
        </Paragraph>
      );
    },
  },
  {
    title: "Source",
    dataIndex: "source",
    key: "source",
    render: (text: string) => <Tag color="blue">{text}</Tag>,
    width: 220,
  },
  {
    title: "Timestamp",
    dataIndex: "timestamp",
    key: "timestamp",
    render: DateRenderer,
    width: 240,
    sorter: (a: any, b: any) =>
      new Date(a.timestamp).getTime() - new Date(b.timestamp).getTime(),
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }: any) => (
      <Space direction="vertical" style={{ padding: 8 }}>
        <DatePicker.RangePicker
          value={selectedKeys[0] || []}
          onChange={(dates) => {
            if (dates && dates[0] && dates[1]) {
              setSelectedKeys([
                [dates[0].startOf("day"), dates[1].endOf("day")],
              ]);
            } else {
              setSelectedKeys([]);
            }
          }}
          allowClear
        />
        <Space>
          <a onClick={() => confirm()}>Filter</a>
          <a onClick={() => clearFilters?.()}>Reset</a>
        </Space>
      </Space>
    ),
    onFilter: (value: [dayjs.Dayjs, dayjs.Dayjs], record: any) => {
      const [start, end] = value;
      const timestamp = dayjs(record.timestamp);
      return timestamp.isAfter(start) && timestamp.isBefore(end);
    },
  },
];
